import React, {
    useEffect,
    useState
} from 'react';
import { Link } from 'react-router-dom';
import './mainPortfolio.css';
import getImageUrl from '../../utils/getImageUrl';
import API_BASE_URL from '../../config/api';

const MainPortfolio = () => {
    const itemsPerPage = 4;

    const [portfolioList, setPortfolioList] =
        useState([]);

    const [currentPage, setCurrentPage] =
        useState(0);

    const [isLoading, setIsLoading] =
        useState(true);

    const [loadError, setLoadError] =
        useState('');

    /*
     * ================================================
     * PORTFOLIO DATA
     * ================================================
     */
    useEffect(() => {
        const fetchPortfolios = async () => {
            try {
                setIsLoading(true);
                setLoadError('');

                const response = await fetch(
                    `${API_BASE_URL}/api/portfolios/public`
                );

                const result =
                    await response.json();

                if (!response.ok) {
                    throw new Error(
                        result.message ||
                        '시공사례를 불러오지 못했습니다.'
                    );
                }

                const portfolios =
                    (result.portfolios || [])
                        .map((item) => ({
                            id: item.portfolio_id,
                            category:
                                item.category || '',
                            title:
                                item.title || '',
                            location:
                                item.location || '',
                            product:
                                item.product || '',
                            image:
                                item.thumbnail_image
                                    ? getImageUrl(item.thumbnail_image)
                                    : '',
                            createdAt:
                                item.created_at || ''
                        }))
                        .sort((a, b) => {
                            return (
                                new Date(b.createdAt) -
                                new Date(a.createdAt)
                            );
                        });

                setPortfolioList(
                    portfolios
                );

                setCurrentPage(0);
            } catch (error) {
                console.error(
                    '메인 시공사례 조회 오류:',
                    error
                );

                setLoadError(
                    error.message
                );
            } finally {
                setIsLoading(false);
            }
        };

        fetchPortfolios();
    }, []);

    /*
     * ================================================
     * PAGINATION
     * ================================================
     */
    const totalPages =
        Math.ceil(
            portfolioList.length /
            itemsPerPage
        );

    const startIndex =
        currentPage *
        itemsPerPage;

    const visiblePortfolio =
        portfolioList.slice(
            startIndex,
            startIndex +
            itemsPerPage
        );

    /*
     * ================================================
     * PREVIOUS
     * ================================================
     */
    const handlePrev = () => {
        if (totalPages <= 1) {
            return;
        }

        setCurrentPage((prev) =>
            prev === 0
                ? totalPages - 1
                : prev - 1
        );
    };

    /*
     * ================================================
     * NEXT
     * ================================================
     */
    const handleNext = () => {
        if (totalPages <= 1) {
            return;
        }

        setCurrentPage((prev) =>
            prev === totalPages - 1
                ? 0
                : prev + 1
        );
    };

    return (
        <section className="main-portfolio">
            <div className="main-portfolio-inner">

                {/* HEADING */}
                <div className="main-portfolio-heading">
                    <div>
                        <p className="main-portfolio-label">
                            PORTFOLIO
                        </p>

                        <h2>
                            최신 시공사례
                        </h2>

                        <p className="main-portfolio-description">
                            엠티미디어의 다양한 시공 사례를 확인해보세요.
                        </p>
                    </div>

                    <Link
                        to="/portfolio"
                        className="main-portfolio-more"
                    >
                        전체 시공사례 보기

                        <span>
                            →
                        </span>
                    </Link>
                </div>

                {/* LOADING */}
                {isLoading && (
                    <div className="main-portfolio-empty">
                        <i className="mdi mdi-loading mdi-spin">
                        </i>

                        <span>
                            시공사례를 불러오는 중입니다.
                        </span>
                    </div>
                )}

                {/* ERROR */}
                {!isLoading && loadError && (
                    <div className="main-portfolio-empty">
                        <i className="mdi mdi-alert-circle-outline">
                        </i>

                        <span>
                            시공사례를 불러오지 못했습니다.
                        </span>
                    </div>
                )}

                {/* PORTFOLIO */}
                {!isLoading &&
                    !loadError &&
                    portfolioList.length > 0 && (
                        <>
                            {/* SLIDER */}
                            <div className="main-portfolio-slider">

                                {totalPages > 1 && (
                                    <button
                                        type="button"
                                        className="main-portfolio-arrow main-portfolio-prev"
                                        onClick={handlePrev}
                                        aria-label="이전 시공사례"
                                    >
                                        <i className="mdi mdi-chevron-left">
                                        </i>
                                    </button>
                                )}

                                <div className="main-portfolio-grid">

                                    {visiblePortfolio.map(
                                        (portfolio) => (
                                            <Link
                                                to={`/portfolio/${portfolio.id}`}
                                                className="main-portfolio-card"
                                                key={portfolio.id}
                                            >
                                                <div className="main-portfolio-image">
                                                    <img
                                                        src={portfolio.image}
                                                        alt={portfolio.title}
                                                    />
                                                </div>

                                                <div className="main-portfolio-card-content">

                                                    <span className="main-portfolio-category">
                                                        {portfolio.category}
                                                    </span>

                                                    <h3>
                                                        {portfolio.title}
                                                    </h3>

                                                    <div className="main-portfolio-info">

                                                        {portfolio.location && (
                                                            <span className="main-portfolio-location">
                                                                {portfolio.location}
                                                            </span>
                                                        )}

                                                        {portfolio.location &&
                                                            portfolio.product && (
                                                                <span className="main-portfolio-divider">
                                                                </span>
                                                            )}

                                                        {portfolio.product && (
                                                            <span className="main-portfolio-product">
                                                                {portfolio.product}
                                                            </span>
                                                        )}

                                                    </div>

                                                </div>
                                            </Link>
                                        )
                                    )}

                                </div>

                                {totalPages > 1 && (
                                    <button
                                        type="button"
                                        className="main-portfolio-arrow main-portfolio-next"
                                        onClick={handleNext}
                                        aria-label="다음 시공사례"
                                    >
                                        <i className="mdi mdi-chevron-right">
                                        </i>
                                    </button>
                                )}

                            </div>

                            {/* PAGINATION */}
                            {totalPages > 1 && (
                                <div className="main-portfolio-pagination">

                                    {Array.from({
                                        length: totalPages
                                    }).map(
                                        (_, index) => (
                                            <button
                                                type="button"
                                                key={index}
                                                className={
                                                    currentPage === index
                                                        ? 'main-portfolio-dot active'
                                                        : 'main-portfolio-dot'
                                                }
                                                onClick={() =>
                                                    setCurrentPage(
                                                        index
                                                    )
                                                }
                                                aria-label={`${index + 1}페이지`}
                                            >
                                            </button>
                                        )
                                    )}

                                </div>
                            )}
                        </>
                    )}

                {/* EMPTY */}
                {!isLoading &&
                    !loadError &&
                    portfolioList.length === 0 && (
                        <div className="main-portfolio-empty">
                            <i className="mdi mdi-image-outline">
                            </i>

                            <span>
                                등록된 시공사례가 없습니다.
                            </span>
                        </div>
                    )}

            </div>
        </section>
    );
};

export default MainPortfolio;